import { UploadFileEvent } from '@eluve/appointment-tasks';
import { createRequiredAction } from '@eluve/frontend-machine-utils';

export const scheduleFileUploadAction = createRequiredAction<UploadFileEvent>(
  'schedule file upload',
);

export type ScheduleFileUploadAction = typeof scheduleFileUploadAction;
